import { useContext } from 'react';
import { ApplicationStateContext } from '../providers/ApplicationStateProvider';

var useApplicationState = () => {
  var context = useContext(ApplicationStateContext);

  if (context === undefined) {
    throw new Error('useApplicationState must be used within a MapProvider[ApplicationStateProvider].');
  }

  return context;
};

export default useApplicationState;